import React from 'react';
import {Field as RUIField} from '@radix-ui/react-form';
import styles from './field.module.scss';
import classNames from 'classnames';
import Label from '../label';
// import {TextInput} from '../input/text-input';
// import {NumberInput} from '../input/number-input';
// import {DateInput} from '../input/date-input';

interface FieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  type: 'text' | 'number' | 'date' | 'textarea';
  horizontal?: boolean;
  labelKind?: 'default' | 'light';
  children?: React.ReactNode;
}

export const Field = ({
  name,
  label,
  placeholder,
  className,
  horizontal = false,
  type,
  labelKind,
  children,
  ...rest
}: FieldProps) => {
  // const Input = useMemo(() => ({
  //   text: TextInput,
  //   number: NumberInput,
  //   date: DateInput,
  // })[type], [type]);

  return (
    <RUIField name={name} className={classNames({[styles.field]: !horizontal, [styles.horizontalField]: horizontal}, className)} {...rest}>
      {!!label && (
        <Label
          kind={labelKind}
          className={classNames({[styles.label]: !horizontal, [styles.horizontalLabel]: horizontal})}
        >
          {label}
        </Label>
      )}
      {/* @ts-ignore */}
      {/* <Input
        name={name}
        placeholder={placeholder}
        {...rest}
      /> */}
      {children}
    </RUIField>
  );
};
